import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import SectionComponent from "components/common/Section/SectionComponent";
import { Button, Label, Table } from "components/bootstrap";
import { StatusIcon } from "components/common";
import ConfirmDialog from "components/common/ConfirmDialog";
import ButtonToolbar from "components/bootstrap/ButtonToolbar";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import usePublicNotifications from "./usePublicNotifications";
import ModalForm from "./ModalForm";
const StyledTable = styled(Table)`
  .form-group {
    margin: 0;

    .checkbox {
      margin: 0;
    }
  }

  tbody > tr > td {
    vertical-align: middle;
  }
`;
const TitleTH = styled.th`
  width: 35%;
`;
const BooleanTH = styled.th`
  width: 8%;
  text-align: center;
`;
const VariantTH = styled.th`
  min-width: 10%;
  text-align: center;
`;
const ActionsTD = styled.td`
  text-align: right;
`;
const OptionsTD = styled.td`
  text-align: center;
`;
const PublicNotifications = () => {
  const [showModal, setShowModal] = useState(false);
  const [deletedData, setDeletedData] = useState({ title: void 0, id: void 0 });
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editingID, setEditingID] = useState(void 0);
  const { notifications, onCreatePublicNotification, onDeletePublicNotification, onUpdatePublicNotification } = usePublicNotifications();
  const isEmpty = Object.keys(notifications).length === 0;
  const sendTelemetry = useSendTelemetry("public-notification");
  const toggleShowConfirmDelete = () => {
    setShowConfirmDelete(!showConfirmDelete);
  };
  const toggleShowModal = () => {
    setShowModal(!showModal);
    setEditing(false);
    setEditingID(void 0);
  };
  const handleCreateNotification = (values) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.CUSTOMIZATION.NOTIFICATION_CREATED, {
      app_pathname: "customization"
    });
    return onCreatePublicNotification(values).then(toggleShowModal);
  };
  const handleEditNotification = (values) => onUpdatePublicNotification(editingID, values).then(toggleShowModal);
  const showConfirmation = ({ title, id }) => {
    setDeletedData({ title, id });
    toggleShowConfirmDelete();
  };
  const showEditModal = (id) => {
    setEditing(true);
    setEditingID(id);
    setShowModal(!showModal);
  };
  const handleDelete = (id) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.CUSTOMIZATION.NOTIFICATION_DELETED, {
      app_pathname: "customization",
      app_action_value: "delete"
    });
    return onDeletePublicNotification(id).then(toggleShowConfirmDelete);
  };
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: "Public Notifications", headerActions: /* @__PURE__ */ React.createElement(Button, { onClick: toggleShowModal }, "Create") }, isEmpty ? /* @__PURE__ */ React.createElement("strong", null, "No notifications available.") : /* @__PURE__ */ React.createElement(StyledTable, { condensed: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(TitleTH, null, "Title"), /* @__PURE__ */ React.createElement(BooleanTH, null, "Active"), /* @__PURE__ */ React.createElement(BooleanTH, null, "Dismissible"), /* @__PURE__ */ React.createElement(BooleanTH, null, "At Login"), /* @__PURE__ */ React.createElement(BooleanTH, null, "Global"), /* @__PURE__ */ React.createElement(VariantTH, null, "Variant"), /* @__PURE__ */ React.createElement("th", null, "\xA0"))), /* @__PURE__ */ React.createElement("tbody", null, Object.keys(notifications).map((notificationID) => {
    const currentNotification = notifications[notificationID];
    return /* @__PURE__ */ React.createElement("tr", { key: notificationID }, /* @__PURE__ */ React.createElement("td", null, currentNotification.title), /* @__PURE__ */ React.createElement(OptionsTD, null, /* @__PURE__ */ React.createElement(StatusIcon, { active: currentNotification.isActive })), /* @__PURE__ */ React.createElement(OptionsTD, null, /* @__PURE__ */ React.createElement(StatusIcon, { active: currentNotification.isDismissible })), /* @__PURE__ */ React.createElement(OptionsTD, null, /* @__PURE__ */ React.createElement(StatusIcon, { active: currentNotification.atLogin })), /* @__PURE__ */ React.createElement(OptionsTD, null, /* @__PURE__ */ React.createElement(StatusIcon, { active: currentNotification.isGlobal })), /* @__PURE__ */ React.createElement(OptionsTD, null, /* @__PURE__ */ React.createElement(Label, { bsStyle: currentNotification.variant }, currentNotification.variant.toUpperCase())), /* @__PURE__ */ React.createElement(ActionsTD, null, /* @__PURE__ */ React.createElement(ButtonToolbar, { className: "pull-right" }, /* @__PURE__ */ React.createElement(Button, { onClick: () => showEditModal(notificationID), bsSize: "xs" }, "Edit"), /* @__PURE__ */ React.createElement(
      Button,
      {
        onClick: () => {
          showConfirmation({ title: currentNotification.title, id: notificationID });
        },
        bsStyle: "danger",
        bsSize: "xs"
      },
      "Delete"
    ))));
  }))), /* @__PURE__ */ React.createElement(
    ModalForm,
    {
      show: showModal,
      toggleShowModal,
      onSubmit: editing ? handleEditNotification : handleCreateNotification,
      submitButtonText: editing ? "Update notification" : "Create notification",
      submitLoadingText: editing ? "Updating notification..." : "Creating notification...",
      initialValues: editing ? notifications[editingID] : {
        title: "",
        shortMessage: "",
        longMessage: "",
        isActive: true,
        isDismissible: false,
        atLogin: false,
        isGlobal: false,
        variant: "default",
        hiddenTitle: false
      }
    }
  ), /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showConfirmDelete,
      onConfirm: () => handleDelete(deletedData.id),
      onCancel: toggleShowConfirmDelete,
      title: "Are you sure?"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "You are about to permanently delete ", /* @__PURE__ */ React.createElement("strong", null, deletedData.title), "."), /* @__PURE__ */ React.createElement("p", null, "Do you wish to continue?"))
  ));
};
export default PublicNotifications;
